import React, { useLayoutEffect, useRef, useEffect } from 'react'
import { SvgWarning } from '../assets/images'
import CustomButton from './CustomButton'
import { noop } from 'lodash'
import { ConfirmDialogProps } from '../utils'
import CustomDialog from './CustomDialog'

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  cancelButtonText = 'No',
  confirmButtonText = 'Yes',
  showCloseButtton = false,
  message = '',
  onCancel = noop,
  onConfirm = noop,
  width = '',
  confirmButtonWidth,
}) => {
  const dialogRef = useRef<HTMLDialogElement>(null)
  const dialogWrapperRef = useRef<HTMLDivElement>(null)
  useLayoutEffect(() => {
    dialogRef.current?.close()
  }, [open])
  useEffect(() => {
    if (dialogRef.current) {
      dialogRef.current.scrollTop = 0
    }
  }, [])

  return (
    <div ref={dialogWrapperRef}>
      <CustomDialog
        isOpen={open}
        onClose={onCancel}
        showCloseButton={showCloseButtton}
        width={width}
      >
        <>
          <div className="px-20 py-8 flex items-center mb-4 justify-center text-sm border-b">
            <div className="flex items-center gap-4">
              <div
                className={`bg-error-100 rounded-full h-[3.625rem] min-w-[3.625rem] flex items-center justify-center self-start`}
              >
                <SvgWarning />
              </div>
              <span>
                <pre className="text-sm font-medium text-accent-700 font-primary">
                  {message}
                </pre>
              </span>
            </div>
          </div>
          <div className={`flex gap-3 items-center justify-end w-full`}>
            <CustomButton
              dataQaId="custom-button-cancel-confirm-dialog"
              onClick={onCancel}
              color="primary"
              className="border border-primary-500 text-xs"
              height="h-8"
              onKeyDown={(e) => {
                if (e?.key === 'Enter' || e?.key === ' ') {
                  e?.preventDefault()
                  e?.stopPropagation()
                  onCancel()
                }
              }}
            >
              {cancelButtonText}
            </CustomButton>
            <CustomButton
              dataQaId="custom-button-accept-confirm-dialog"
              onClick={onConfirm}
              color="primary"
              isFilled={true}
              widthClass={confirmButtonWidth}
              height="h-8"
              onKeyDown={(e) => {
                if (e?.key === 'Enter' || e?.key === ' ') {
                  e?.preventDefault()
                  e?.stopPropagation()
                  onConfirm()
                }
              }}
            >
              {confirmButtonText}
            </CustomButton>
          </div>
        </>
      </CustomDialog>
    </div>
  )
}

export default ConfirmDialog
